import styled from 'styled-components';

export const Container = styled.input`
    border: 1px solid #1E1E24;
    border-radius: 8px;
    width: 273px;
    height: 41px;
    padding-left: 1rem;
    &:focus {
        outline: none;
    }
`;
